import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";
import TermsAu from "../../components/organisms/TermsAu";
import TermsUk from "../../components/organisms/TermsUk";
import { checkIfRequestIsFromMobileApp, checkScrollingDown, getCountrySettings } from "../../helpers/tools";
import { LayoutContext } from "../../components/organisms/Layout/context";
import Tabs from "../../components/atoms/Tabs";
import { TERMS_AND_CONDITIONS_TABS } from "../../helpers/navbarProcessor";
import { useDeviceSize } from "../../helpers/hooks";
import { I18N_NAMESPACES } from "../../helpers/constants";

class TermAndPolicies extends PureComponent {
  static contextType = LayoutContext;

  static propTypes = {
    isTabBarHidden: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showHeaderBarFromChild: true,
    };
    this.previousScrollY = 0;
  }

  componentDidMount() {
    const { showHeaderBarFromChild } = this.state;
    const { setShowHeaderBarFromChild } = this.context;
    setShowHeaderBarFromChild(showHeaderBarFromChild);
    return window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    const { showHeaderBarFromChild } = this.state;
    const { showHeaderBarFromChild: previousShowHeaderBarFromChild } = prevState;
    if (showHeaderBarFromChild !== previousShowHeaderBarFromChild) {
      const { setShowHeaderBarFromChild } = this.context;
      setShowHeaderBarFromChild(showHeaderBarFromChild);
    }
  }

  componentWillUnmount() {
    return window.removeEventListener("scroll", this.handleScroll);
  }

  /**
   * Handler for scroll event listeners,
   * ...to set state to show or hide Header bar.
   * */
  handleScroll = () => {
    const { isScrollingDown, yValue } = checkScrollingDown(this.previousScrollY);
    this.previousScrollY = yValue;
    const { showHeaderBarFromChild } = this.state;
    if (showHeaderBarFromChild === isScrollingDown) {
      // CASE: If scrolling down, hides header if shown
      // and, if scrolling up, shows header if hidden.
      this.setState({ showHeaderBarFromChild: !isScrollingDown });
    }
  };

  /**
   * Being such a long file to translate, we opted to have one component
   * by country with all the content specific to that country.
   * */
  returnCountryContent = (showHeaderBarFromChild) => {
    const { IS_COUNTRY_UK } = getCountrySettings();
    const isCountryUK = !!IS_COUNTRY_UK;
    if (isCountryUK) {
      return <TermsUk showHeaderBarFromChild={showHeaderBarFromChild} />;
    }
    return <TermsAu showHeaderBarFromChild={showHeaderBarFromChild} />;
  };

  render() {
    const { showHeaderBarFromChild } = this.state;
    const { isTabBarHidden, t } = this.props;
    const tabs = TERMS_AND_CONDITIONS_TABS;
    const translatedTabs = tabs.map((tab) => ({
      url: tab.url,
      text: t(tab.i18nKey),
    }));
    return (
      <>
        {!isTabBarHidden && <Tabs tabs={translatedTabs} />}
        {this.returnCountryContent(showHeaderBarFromChild)}
      </>
    );
  }
}

const TermAndPoliciesWrapper = (props) => {
  const { isSmall } = useDeviceSize();
  const isTabBarHidden = isSmall && checkIfRequestIsFromMobileApp();
  const { t } = useTranslation([I18N_NAMESPACES.TOP_NAVBAR]);

  return <TermAndPolicies {...props} isTabBarHidden={isTabBarHidden} t={t} />;
};

export default TermAndPoliciesWrapper;
